import { DweenTimeUnitEnum } from "utils/time-utils";
import { Instant } from "@js-joda/core";
import { OldDashboardComponent } from "./DashboardComponent";
import { DashboardComponentGroup } from "./DashboardComponentGroup";
import { DashboardTabReportOptions } from "./DashboardReportOptions";

export interface DashboardTabModel {
  uuid: string;
  title: string;
  tabGroupId?: string;
  componentGroups: Array<DashboardComponentGroup>;
  contextConfig?: ContextConfig;
  reportOptions?: DashboardTabReportOptions;
}

export interface OldDashboardTabModel {
  components: Array<OldDashboardComponent>;
  uuid: string;
  title: string;
}

export interface LagLeadLoadConfig {
  lag?: number;
  lead?: number;
  lagUnit?: DweenTimeUnitEnum;
  leadUnit?: DweenTimeUnitEnum;
  lagUnits?: DweenTimeUnitEnum;
  leadUnits?: DweenTimeUnitEnum;
}

export interface OffsetLoadConfig {
  timeOffset?: number;
  timeOffsetUnit?: DweenTimeUnitEnum;
}

export interface DateLoadConfig extends LagLeadLoadConfig, OffsetLoadConfig {
  alignStartTo?: DweenTimeUnitEnum;
}

export interface ContextConfig {
  contextType?: ContextTypes;
  showBorders?: boolean;
  config?: DateLoadConfig;

  instantFrom?: Instant;
  instantTo?: Instant;
  instantReferenceTime?: Instant;

  from?: string;
  to?: string;
  referenceTime?: string;
}

export enum ContextTypes {
  NONE = "None",
  SINGLE_DATE_SELECTION_WITH_CONFIG = "Single date selection with config",
  RANGE_DATE_SELECTION = "Range date selection",
  SINGLE_DATE_SELECTION = "Single date selection",
  YEARS_SELECTION = "Years selection",
}
